export function LogoMark({ size = 64, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="ga-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#05324A" />
          <stop offset="1" stopColor="#0A6373" />
        </linearGradient>
      </defs>
      <rect width="100" height="100" rx="24" fill="url(#ga-grad)" />
      <g stroke="#33D9B2" strokeWidth="5" strokeLinecap="round">
        <line x1="66" y1="26" x2="66" y2="15" />
        <line x1="73" y1="30" x2="80" y2="22" />
        <line x1="77" y1="38" x2="87" y2="34" />
      </g>
      <g fill="none" stroke="#fff" strokeWidth="6.5" strokeLinejoin="round" strokeLinecap="round">
        <path d="M47 30 L67 41 L67 63 L47 74 L27 63 L27 41 Z" />
        <path d="M27 41 L47 52 L67 41" />
        <path d="M47 52 L47 74" />
      </g>
      <circle cx="67" cy="67" r="14" fill="#13C9A3" />
      <path d="M60 67 L65 72 L74 62" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function LogoText({ light = false, className = "" }) {
  return (
    <span className={`font-bold tracking-tight ${className}`} style={{ color: light ? "#fff" : "var(--ga-text)" }}>
      Clicou, <span style={{ color: "#13C9A3" }}>Guardou!</span>
    </span>
  );
}
